import React, { useState } from 'react'
import styled from 'styled-components';
import { IcoMoon, Box, Text, EyeVisibleOffIcon, EyeVisibleOnIcon, ResponsiveBox, CloseIcon } from "@usap/uicomponents";

const lightBorderColor = props => props.theme.global.colors['dark-2'];
const darkBorderColor = props => props.theme.global.colors['dark-4'];
const placeholderColor = props => props.theme.global.colors['placeholderColor'];

const CustomOutlinedLabel = styled.label`
  /* Overwite mui style for floating text field. Only applicable for WMo enabled*/

  &.pure-material-textfield-outlined-wmo{
    --pure-material-safari-helper1: ${lightBorderColor}; 
    --pure-material-primary-rgb: ${lightBorderColor};
    --pure-material-onsurface-rgb: ${lightBorderColor};
  }
  
  &.pure-material-textfield-outlined-wmo>input:not(:focus):placeholder-shown{
    border-color: ${({hasError}) => hasError ? '#C33' : darkBorderColor};
  }

  &.pure-material-textfield-outlined-wmo>input:not(:focus)+span,
  &.pure-material-textfield-outlined-wmo>textarea:not(:focus)+span {
    color: ${({hasError}) => hasError ? '#C33' : placeholderColor};
  }
  
  &.pure-material-textfield-outlined-wmo>input:focus{
    border-bottom-color: ${lightBorderColor};
    border-left-color: ${lightBorderColor};
    border-right-color: ${lightBorderColor};
    border-top: none;
  }

  &.pure-material-textfield-outlined-wmo>input{
    padding: 11px 13px 11px;
  }

  &.pure-material-textfield-outlined-wmo>input:not(:focus):placeholder-shown+span{
    line-height: 58px;
  }
`;

const FloatingPasswordInput = props => {
  const {
    resetClick = () => {},
    paddingRight = 46,
    cross = false,
    hasFocus = false,
    ...restProps
  } = props

  const {
    error='',
    label = '',
    placeholder = ' ',
    required = false,
    isWmoEnabled = false,
    hasError = false,
  } = restProps

  const resetHandler = event => {
    setTimeout(() => resetClick(event), 300)
  }

  const [passwordVisibility, setVisibility] = useState(true);
  const [showPassword, toggleShowPassword] = useState(false);

  return (
    <>
    <CustomOutlinedLabel
      style={{ position: 'relative'}}
      className={`pure-material-textfield-outlined ${isWmoEnabled && 'pure-material-textfield-outlined-wmo'}`}
      hasError={hasError}
    >
      <input
        className="floatingInput"
        style={{
          paddingRight:
           cross && hasFocus ? paddingRight + 30 : paddingRight,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          color: hasError && !hasFocus && '#C33',
        }}
        placeholder={placeholder}
        type={showPassword ? "text" : "password"}
        {...restProps}
      />
      <span>
        {label}
        {' '}
        {required && <span style={{ color: 'red', padding: '0 6px' }}>*</span>}
      </span>

      {hasFocus && cross && (
        <Box
          style={{
            position: 'absolute',
            top: "50%",
            right: 52,
            cursor: 'pointer',
            transform: "translateY(-50%)",
          }}
          onMouseDown={resetHandler}
          onTouchStart={resetHandler}
        >
          <IcoMoon icon={CloseIcon} size="24px" color={isWmoEnabled ? "dark-2" : "royalBlue" } />
        </Box>
      )}

        <Box
          justify="center"
          style={{
              position: 'absolute',
              top: "50%",
              right: 16,
              cursor: 'pointer',
              boxShadow: "none",
              transform: "translateY(-50%)",
          }}

          onClick={() => {
              setVisibility(!passwordVisibility);
              toggleShowPassword(!showPassword);
          }}
          >
              <IcoMoon
                  icon={ passwordVisibility ? EyeVisibleOffIcon : EyeVisibleOnIcon}
                    color={isWmoEnabled ? "dark-2" : "royalBlue" }
              />
        </Box>
    </CustomOutlinedLabel>

    {error && <Text
        style={{ display: "block",}}
        color="status-critical"
        size="xsmall"
    >
        {error}
    </Text>}
   </>
  )
}
export default FloatingPasswordInput